export default __webpack_public_path__ + "static/media/team-juls.f19796aa.jpg";